import React, { useState } from 'react';
import './CreatePrivateChatModal.css';

const CreatePrivateChatModal = ({ 
  isOpen, 
  onClose, 
  targetUserID, 
  onCreateChat 
}) => {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) {
      setError('Please enter a message');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await onCreateChat(message.trim());
      setMessage('');
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to create private chat');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setMessage('');
      setError('');
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="create-private-chat-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Start Private Chat</h3>
          <button 
            className="close-button" 
            onClick={handleClose}
            disabled={loading}
          >
            ×
          </button>
        </div>
        
        <div className="modal-content">
          <p className="target-user">
            Send your first message to <strong>{targetUserID}</strong>
          </p>
          
          <form onSubmit={handleSubmit}>
            <div className="message-input-group">
              <label htmlFor="first-message">First Message:</label>
              <textarea
                id="first-message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Type your first message here..."
                maxLength={175}
                rows={4}
                disabled={loading}
                autoFocus
              />
              <div className="character-count">
                {message.length}/175
              </div>
            </div>
            
            {error && (
              <div className="error-message">
                {error}
              </div>
            )}
            
            <div className="modal-actions">
              <button 
                type="button" 
                className="cancel-button"
                onClick={handleClose}
                disabled={loading}
              >
                Cancel
              </button>
              <button 
                type="submit" 
                className="create-button"
                disabled={loading || !message.trim()}
              >
                {loading ? 'Creating...' : 'Start Chat'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreatePrivateChatModal;
